import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {resetEntity, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {deleteUser, loadUser, saveUser} from '../actions/users';
import {defaultState} from '../reducers/entity';
import UserForm from '../components/user/UserForm';
import {Acl, breadcrumbs, Grid} from "./../utils";

class UserEditPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleSaveUser = this.handleSaveUser.bind(this);
	}

	componentWillMount() {
		const {userId} = this.props.match.params;
		if (userId) {
			this.props.loadUser(userId)
		}
	}

	componentWillReceiveProps(nextProps) {
		if ((nextProps.match.params.userId || 'new') !== (this.props.match.params.userId || 'new')) {
			if (nextProps.match.params.userId) {
				this.props.loadUser(nextProps.match.params.userId);
			} else {
				this.props.resetEntity("user");
			}
		}
	}

	componentWillUnmount() {
		this.props.resetEntity("user");
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleSaveUser(user) {
		return this.props.saveUser(user).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const userId = json.response.data.userId;
				let m = json.response.message;
				const d = json.response.data;
				let t = d.firstName + ' ' + d.lastName + ' (ID ' + userId + ')';
				if (m === 'NO_CHANGE') {
					m = 'Uživatel uložen beze změn: ' + t;
				} else if (m === 'UPDATED') {
					m = 'Uživatel úspěšně upraven: ' + t;
				} else if (m === 'CREATED') {
					m = 'Uživatel úspěšně vytvořen: ' + t;
				}
				this.props.showMessage(m);
				return new Promise((resolve, reject) => resolve(this.props.history.push('/uzivatele/' + userId)))
			} else {
				this.props.showMessage("Uložení selhalo: " + (json.error || JSON.stringify(json)), 'error');

				return new Promise((resolve, reject) => resolve())
			}
		})
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;

		if (entity.isFetchingItem || entity.item === null) {
			return Grid.renderIsFetchingData()
		}

		if ((!entity.id && !Acl.isAllowed(session, Acl.right.ADMIN))
			|| (entity.id && !Acl.hasAction(entity.item, Acl.user.EDIT))) {
			return Grid.renderIsDenied()
		}

		const initialValues = entity.item;
		const bc = [
			{url: '/uzivatele', title: 'Uživatelé'}
		];
		if (params.userId) {
			bc.push({url: '/uzivatele/' + params.userId, title: entity && entity.item && entity.item.userId ? entity.item.lastName : '...', literal: true});
			bc.push({url: '/uzivatele/' + params.userId + '/uprava', title: 'Úprava'});
		} else {
			bc.push({url: '/uzivatele/novy', title: 'Nový'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<UserForm {...entity} initialValues={initialValues}
					onSaveUser={this.handleSaveUser}
					onFetchEnums={this.handleFetchEnums} enums={enums} session={session}/>
			</div>
		)
	}
}

UserEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadUser: PropTypes.func.isRequired,
	saveUser: PropTypes.func.isRequired,
	deleteUser: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {users},
		enums,
		session
	} = state;

	const entity = ownProps.match.params.userId
		? (users[ownProps.match.params.userId] || defaultState)
		: (users['new'] || Object.assign(defaultState, {item: {}}));

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadUser,
	saveUser,
	deleteUser,
	loadGeneralEnum,
	showMessage,
	resetEntity
})(UserEditPage)



// WEBPACK FOOTER //
// ./src/containers/UserEditPage.js